import { Feature } from '@nirvana/shared/constants';
import { ConsoleRequest, DataProviderEntity, DataProviderType } from './request';
import { GetCompanyFeaturesResponse } from '../response';

export class FeaturesManager {
  static async getFeaturesByCompany(payload: GetCompanyFeaturesPayload): Promise<Feature[]> {
    let response;

    try {
      response = await ConsoleRequest.createRequest<GetCompanyFeaturesResponse>({
        dataProviderType: DataProviderType.CORE,
        dataProviderEntity: DataProviderEntity.SYSTEM,
        endpoint: FeaturesManager.endpoint,
        method: FeaturesManager.EndpointMethod.GET_FEATURES_BY_COMPANY,
        payload: payload,
      });
    } catch (e) {
      return [];
    }

    return response.features;
  }
}

export namespace FeaturesManager {
  export const endpoint = 'FeaturesManager';

  export enum EndpointMethod {
    GET_FEATURES_BY_COMPANY = 'getFeaturesByCompany',
  }
}

export interface GetCompanyFeaturesPayload {
  companyId: string;
}

export interface GetCompaniesFeaturesPayload {
  companyIds: string[];
}
